// extracted by mini-css-extract-plugin
export default {"title":"Category_title__uR1Zr"};